import classNames from 'classnames';
import { type ComponentProps, memo } from 'react';

export type ModalDescriptionProps = ComponentProps<'p'>;

export const ModalDescription = memo(({ className, ...restOfProps }: ModalDescriptionProps) => {
  return <p className={classNames('text-14 text-gray-11', className)} {...restOfProps} />;
});

ModalDescription.displayName = 'ModalDescription';
